// Layout grid overlay (development + staging).
//
// Renders a fixed-position overlay showing the responsive column grid
// (4 / 8 / 12 cols) so we can align content against the design system
// while building responsive layouts.
//
// Toggle via:
//   - Keyboard:  Ctrl/Cmd + Alt + G
//   - Console:   window.toggleLayoutGrid()
//
// State persists across reloads in localStorage. This component is only
// mounted in development and on staging (see layouts/application.html.erb),
// so it never ships to production.

import React, { useEffect, useState } from 'react';

import localStorage from 'views_shared/app/javascript/services/localStorage';

const STORAGE_KEY = 'layout-grid-visible';

function LayoutGridOverlay() {
  const [visible, setVisible] = useState(() => localStorage.devTools.get(STORAGE_KEY, false) === true);

  useEffect(() => {
    const toggle = () => {
      setVisible((prev) => {
        const next = !prev;
        localStorage.devTools.set(STORAGE_KEY, next);
        return next;
      });
    };

    const handleKeyDown = (event) => {
      const isToggleCombo = (event.ctrlKey || event.metaKey) && event.altKey && event.key.toLowerCase() === 'g';
      if (!isToggleCombo) return;
      event.preventDefault();
      toggle();
    };

    window.addEventListener('keydown', handleKeyDown);
    window.toggleLayoutGrid = toggle;

    // eslint-disable-next-line no-console
    console.info('Layout grid overlay ready — toggle with Ctrl/Cmd+Alt+G or window.toggleLayoutGrid()');

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      delete window.toggleLayoutGrid;
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="layout-grid-overlay" aria-hidden="true">
      <div className="grid">
        {Array.from({ length: 12 }).map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className="bar" />
        ))}
      </div>
    </div>
  );
}

export default LayoutGridOverlay;
